import NavBar from "./components/NavBar";
import HeroSection from "./components/HeroSection";
import WhoIAmSection from "./components/WhoIAmSection";
import HowIHelpSection from "./components/HowIHelpSection";
import SubmitProjectSection from "./components/SubmitProjectSection";
import InsightsSection from "./components/InsightsSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <div className="font-sans">
      <NavBar />
      <HeroSection />
      <WhoIAmSection />
      <HowIHelpSection />
      <SubmitProjectSection />
      <InsightsSection />
      <HowItWorksSection />
      <FooterSection />
    </div>
  );
}
